import { decodeJwt, JWTPayload } from 'jose';

export type JWTExtendedPayload = Record<string, string | number> & JWTPayload;

let cachedToken: string | undefined = undefined;
let claimsCache: JWTExtendedPayload = {};

export const readTokenClaimsCached = (accessToken: string) => {
  if (cachedToken === accessToken) {
    return claimsCache;
  }

  const claims = accessToken ? decodeJwt(accessToken) : undefined;

  if (accessToken && claims) {
    cachedToken = accessToken;
    claimsCache = claims as unknown as JWTExtendedPayload;
  }

  return claimsCache;
};
